import React, { useEffect, useState } from 'react'
import { useFlexSearch } from 'react-use-flexsearch'

import { localizeUrl } from '@infrastructure/Url/localizeUrls/localizeUtilities'
import { useTranslation } from '@src/Application/Interfaces/Hooks/useTranslation'
import { LocalSearchType } from '@src/Application/Types/ComponentTypes'

import { Backdrop, Description, Input, Link, ResultsWrapper, Title, Wrapper } from './SearchElement.styled'
import { closeDropdown, onChange, Result, toggleDropdown } from './utils'

type Props = {
    className?: string
    defaultOpen?: boolean
    localSearch: LocalSearchType
}

export const SearchElement = (props: Props): JSX.Element => {
    const { className, localSearch, defaultOpen = false } = props

    const { t } = useTranslation()
    const [query, setQuery] = useState<string>('')
    const [open, setOpen] = useState<boolean>(defaultOpen)

    const results = useFlexSearch(query, localSearch.index, localSearch.store)

    useEffect(toggleDropdown({ query, results, setOpen }), [query, results])

    return (
        <Wrapper className={className}>
            <Backdrop onClick={closeDropdown(setOpen)} open={open} $layerIndex={1} />
            <Input
                value={query}
                name="searchTerm"
                label={t('searchPlaceholder')}
                onChange={onChange(setQuery)}
                onFocus={toggleDropdown({ query, results, setOpen })}
                autoComplete="off"
                optional
            />
            {open && (
                <ResultsWrapper>
                    {results.map((res: Result) => {
                        if (!res) return null

                        const fullPath = localizeUrl(res.locale, res.pageUrl)

                        return (
                            <Link to={fullPath} key={fullPath}>
                                <Title>{res.title}</Title>
                                {res.shortDescription && <Description>{res.shortDescription}</Description>}
                            </Link>
                        )
                    })}
                </ResultsWrapper>
            )}
        </Wrapper>
    )
}
